import { Injectable } from '@angular/core';
import { SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS } from '../interfaces/save-quote-data.interface';
import { ApplicationRecord } from '../../interfaces/application-record.interface';
import { SAVE_QUOTE_CARD_TYPE } from '../interfaces/saved-quotes.input.interface';

@Injectable({
  providedIn: 'root',
})
export class SavedQuotesDocumentUploadUtilityService {
  
    getDocumentUploadSEPStatus(
      applicationRecord: ApplicationRecord
    ): SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS {
      return applicationRecord?.enrollmentObjectJson?.saveQuoteData?.actionList?.documentUpload?.status;
    }
  
    getDisplayDocumentUploadIndicator(
      applicationRecord: ApplicationRecord,
      quoteType: SAVE_QUOTE_CARD_TYPE
    ): boolean {
      return (
        quoteType === SAVE_QUOTE_CARD_TYPE.DOCUMENT_UPLOAD_REQUEST &&
        applicationRecord.enrollmentObjectJson.saveQuoteData?.state.componentStates.LifeEvent?.isDocumentUploadRequired
      ) || (
        applicationRecord.enrollmentObjectJson.saveQuoteData?.actionList?.documentUpload.status === SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS.STEP_2_COMPLETED
      )
    }
}
